import React from "react";

const WhyInvestEtf3 = ({ ...rest }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="49"
            height="49"
            viewBox="0 0 49 49"
            fill="none"
            {...rest}
        >
            <rect opacity="0.2" x="4.25" y="5" width="44" height="44" fill="#10B981" />
            <rect x="1" y="1" width="44" height="44" stroke="#059669" strokeWidth="2" />
            <path
                d="M26.6668 28.4999L28.5002 30.3333L32.1668 26.6666M32.1668 21.1666H13.8335M32.1668 22.9999V19.5166C32.1668 18.4898 32.1668 17.9764 31.967 17.5843C31.7912 17.2393 31.5108 16.9588 31.1658 16.7831C30.7736 16.5833 30.2603 16.5833 29.2335 16.5833H16.7668C15.7401 16.5833 15.2267 16.5833 14.8345 16.7831C14.4895 16.9588 14.2091 17.2393 14.0333 17.5843C13.8335 17.9764 13.8335 18.4898 13.8335 19.5166V26.4833C13.8335 27.51 13.8335 28.0234 14.0333 28.4156C14.2091 28.7605 14.4895 29.041 14.8345 29.2168C15.2267 29.4166 15.7401 29.4166 16.7668 29.4166H23.0002"
                stroke="#059669"
                strokeWidth="1.83563"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default WhyInvestEtf3;
